export const ReportFormats = {
	PDF: "PDF",
	Excel: "Excel",
};

export const ReportFormatOptions = [
	{ value: ReportFormats.PDF, label: "PDF" },
	{ value: ReportFormats.Excel, label: "Excel" },
];
